import { render, staticRenderFns } from "./paymenttable.vue?vue&type=template&id=deb113a0&"
import script from "./paymenttable.vue?vue&type=script&lang=js&"
export * from "./paymenttable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports